import { Paginator, Message } from '@twilio/conversations';

import { IConversationMessage } from '@/utils/conversation/types';

export const partitionMessageHeritage = (messages: Array<IConversationMessage>) => {
  if (!messages) {
    return;
  }

  const data = messages.reduce(
    (acc, iter) => {
      const parentMessageId = iter.attributes?.parentMessageId;

      if (parentMessageId) {
        const currentChildren = acc.child[parentMessageId] || [];

        return { ...acc, child: { ...acc.child, [parentMessageId]: [...currentChildren, iter] } };
      }

      return { ...acc, parent: [...acc.parent, iter] };
    },
    { parent: [], child: {} }
  );

  return data;
};

export const getSortedMessages = (data: Paginator<Message>) => {
  if (data?.items) {
    const { parent, child } = partitionMessageHeritage(data.items as Array<IConversationMessage>);

    const sortedMessages = parent.reduce((acc, message) => {
      if (child[message.sid]) {
        return [...acc, message, ...child[message.sid]];
      }
      return [...acc, message];
    }, []);

    return sortedMessages;
  }
  return [];
};

export const mergePaginators = (a: Paginator<Message>, b: Paginator<Message>) => ({
  ...b,
  items: [...b.items, ...a.items],
});
